export default "__VITE_ASSET__D9kb4Hbt__"